<template>
<transition name="c-sd">
<div v-show="isShow" class="c-sd">
  <div ref="c-sd__text2" class="c-sd__text c-sd__text--bg">
    <span>S</span>
    <span>C</span>
    <span>R</span>
    <span>O</span>
    <span>L</span>
    <span>L</span>
    <span>D</span>
    <span>O</span>
    <span>W</span>
    <span>N</span>
  </div>
  <div ref="c-sd__text1" class="c-sd__text" @click="gotoNext">
    <span>S</span>
    <span>C</span>
    <span>R</span>
    <span>O</span>
    <span>L</span>
    <span>L</span>
    <span>D</span>
    <span>O</span>
    <span>W</span>
    <span>N</span>
  </div>
</div>
</transition>
</template>

<script>
import {gsap, Power3} from 'gsap/all';

export default {
  data() {
    return {
      strings1: null,
      strings2: null,
    }
  },
  computed: {
    isShow() {
      return this.$store.getters.isShowScrolldown;
    },
  },
  watch: {
    isShow (isNew, isOld) {
      if (isNew) {
        this.start();
      }
    },
  },
  mounted() {
    this.strings1 = this.$refs['c-sd__text1'].querySelectorAll('span');
    this.strings2 = this.$refs['c-sd__text2'].querySelectorAll('span');
  },
  methods: {
    start() {
      const tl = gsap.timeline({
        onComplete: this.startComp
      });
      tl.fromTo(this.strings1, {
        y: '0%',
      }, {
        duration: 0.5,
        y: '100%',
        ease: Power3.easeOut,
        stagger: 0.05,
      })
      .fromTo(this.strings2, {
        y: '0%',
      }, {
        duration: 0.5,
        y: '100%',
        ease: Power3.easeOut,
        stagger: 0.05,
      }, 0.1);
    },
    startComp() {
      gsap.set(this.strings1, {y: '0%'});
      gsap.set(this.strings2, {y: '0%'});
      gsap.delayedCall(3, this.start);
    },
    gotoNext() {
      // if (this.isPageTransition) return;
      // this.isPageTransition = true;
      if (this.$route.name === 'index') {
        this.$store.commit('setShowVideo', false);
        this.$store.commit('setStartTop', false);
        this.$store.commit('setShowTop', false);
      } else {

      }

    },
  }
}
</script>